import React, { ReactElement } from 'react';
import { dotStyle, flex } from '@fabric-ui/theme';
import { emptyArray, emptyObject, noop } from '@fabric-ui/utils';
import { Box, FormControl, FormControlLabel, InputLabel, Radio, RadioGroup, SxProps } from '@mui/material';

export interface RadioButtonProps {
  label?: string;
  value?: string | number | boolean;
  options?: { title: string | ReactElement<any>; value: string | number | boolean }[];
  onChange?: (arg0: string) => void;
  sx?: SxProps;
  isHorizontal?: boolean;
  disabled?: boolean;
}
export const RadioButton: React.FC<RadioButtonProps> = ({
  label = '',
  value = '',
  onChange = noop,
  options = emptyArray,
  sx = emptyObject,
  isHorizontal = true,
  disabled = false,
}) => {
  // const { palette } = useTheme();

  return (
    <FormControl
      component="fieldset"
      sx={{
        mb: '6px',
        ...sx,
      }}
      disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <RadioGroup
        row
        aria-label={label}
        onChange={({ target }) => onChange(target.value)}
        value={value}
        sx={{
          ...(isHorizontal ? flex.itemsCenter : flex.colItemsStart),
          gap: isHorizontal ? 1 : 2,
        }}>
        {options.map(({ title, value: val }) => (
          <FormControlLabel
            key={val}
            value={val}
            label={title}
            sx={{ marginLeft: 0, marginRight: '24px', gap: 1 }}
            control={
              <Radio
                sx={{
                  p: 0,
                  alignSelf: 'flex-start',
                  mt: '0.2em',
                  'input + div': {
                    ...dotStyle(undefined, 16),
                    transition: theme =>
                      theme.transitions.create(['border-color', 'background-color'], { duration: theme.transitions.duration.shorter }),
                  },
                  ':hover': {
                    backgroundColor: 'transparent',
                    'input + div': { borderColor: 'var(--color-content-interactive-primary-hover)' },
                    '&.Mui-checked input + div': { borderColor: 'var(--color-surface-interactive-primary-hover)' },
                  },
                  '&.Mui-disabled': {
                    'input + div': {
                      backgroundColor: 'var(--color-surface-interactive-primary-disabled)',
                      borderColor: 'var(--color-border-interactive-primary-disabled)',
                    },
                    '&.Mui-checked input + div': {
                      backgroundColor: 'var(--color-surface-interactive-primary-disabled)',
                      borderColor: 'var(--color-content-base-disabled)',
                    },
                  },
                }}
                checkedIcon={
                  <Box
                    sx={{
                      border: '4px solid',
                      backgroundColor: 'var(--color-surface-base-secondary)',
                      borderColor: 'var(--color-surface-interactive-primary-default)',
                    }}
                  />
                }
                icon={<Box sx={{ border: '1px solid', borderColor: 'var(--color-content-base-tertiary)' }} />}
              />
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
